import axios from 'axios';
import * as api from '~/api/index';
import * as userApi from '~/api/user';
import * as types from '~/types';
import { reloadRoute } from '~/utils';
import { getUrlQuery } from '~/utils/util';

export const state = () => {
  return {
    loginInfo: null,
    isLoginFormShow: false,
    isRegistFirst: true,
    followList: {},
    isLogin: false,
    focusList: {},
    stockFocusList: {},
    vipMemberInfo: null, //  会员页用户会员信息
    bindWechatInfo: null, //  绑定微信用户消息
  };
};

//  userInfo结构如下
//  "user": {
//    "userId": 175959,
//    "nickname": "zllll",
//    "avatar": "http: // img4.gelonghui.com/headdefault/avatar_default2.png",
//    "sex": null,
//    "createDate": 1541989917,
//    "userBrief": null,
//    "state": null,
//    "city": null,
//    "birth": null,
//    "country": "中国",
//    "userType": 0,
//    "email": null,
//    "countryCode": "86",
//    "phone": "13068714875",
//    "inviteCode": "A6J8OG"
//  }
export const getters = {
  loginInfo: (state) => {
    return state.loginInfo || null;
  },
  userInfo: (state) => {
    return state.loginInfo ? state.loginInfo.user : null;
  },
  isLogin: (state) => {
    return state.isLogin;
  },
  avatar: (state, getters) => {
    return state.loginInfo ? state.loginInfo.avatar : '';
  },
  userId: (state, getters) => {
    return state.loginInfo ? state.loginInfo.id : '';
  },
  roleList: (state) => {
    return state.loginInfo ? state.loginInfo.roles : '';
  },
  /**
   * @description 用户验证相关状态
   * @param { object } state 操作对象
   */
  kyc: (state) => {
    return state.loginInfo ? state.loginInfo.kyc : null;
  },
  isFollow: (state) => {
    return (id) => {
      return state.followList[id] === true;
    };
  },
  isFocusStock: (state) => {
    return (id) => {
      return state.stockFocusList[id.toLowerCase()];
    };
  },
  userBrief: (state) => {
    return state.loginInfo ? state.loginInfo.brief : '';
  },
  nickname: (state, getters) => {
    return state.loginInfo ? state.loginInfo.nick : '';
  },
  followerCnt: (state) => {
    return state.loginInfo ? state.loginInfo.userCount.fans : 0;
  },
  followingCnt: (state) => {
    return state.loginInfo ? state.loginInfo.userCount.follow : 0;
  },
  favCnt: (state) => {
    return state.loginInfo ? state.loginInfo.userCount.favorite : 0;
  },
  postCnt: (state) => {
    return state.loginInfo ? state.loginInfo.userCount.post : 0;
  },
  stockCnt: (state) => {
    return state.loginInfo ? state.loginInfo.userCount.optionalStock : 0;
  },
  guruCoin: (state) => {
    return state.loginInfo ? state.loginInfo.account.coin : 0;
  },
  userLevel: (state) => {
    return state.loginInfo ? state.loginInfo.level.currentLevel : 0;
  },
  //  isFocus: (state) => {
  //    return (id) => {
  //      return state.focusList[id] === true;
  //    }
  //  }
  vipInfo: (state) => {
    return state.loginInfo && state.loginInfo.vip
      ? {
          vipType: state.loginInfo.vip.type,
          vipIsTrial: state.loginInfo.vip.isTrial,
          vipExpireTimestamp: state.loginInfo.vip.expireTimestamp,
        }
      : {
          vipType: '',
          vipIsTrial: '',
          vipExpireTimestamp: null,
        };
  },
  vipMemberInfo: (state) => {
    return state.vipMemberInfo;
  },
  bindWechatInfo: (state) => {
    return state.bindWechatInfo;
  },
};

export const mutations = {
  [types.USER_SIGNIN](state, data) {
    localStorage.setItem('user', JSON.stringify(data));
    localStorage.setItem('accessToken', JSON.stringify(data));
    sessionStorage.setItem('user', JSON.stringify(data));
    sessionStorage.setItem('accessToken', JSON.stringify(data));
    const loginInfo = JSON.parse(localStorage.getItem('user'));
    state.loginInfo = loginInfo;
    state.isLogin = true;
    //  console.log(state.loginInfo)
  },
  [types.USER_ISLOGIN](state, isLogin) {
    state.isLogin = isLogin;
  },
  [types.USER_SIGNOUT](state) {
    localStorage.removeItem('user');
    localStorage.removeItem('accessToken');
    sessionStorage.removeItem('user');
    sessionStorage.removeItem('accessToken');
    state.loginInfo = null;
    state.roleList = '';
    state.isLogin = false;
    //  清空用户其他相关数据
    state.followList = {};
    state.focusList = {};
    state.stockFocusList = {};
  },
  [types.HIDE_LOGIN_FORM](state) {
    document.body.style.overflowY = '';
    state.isRegistFirst = false;
    state.bindWechatInfo = null;
    state.isLoginFormShow = false;
    state.isbindFromShow = false;
    //  如果是绑定手机号过程合关闭弹窗，路由重定向
    const path = location.pathname;
    const pathQuery = getUrlQuery(location.href);
    if (pathQuery && pathQuery.wxcode) {
      delete pathQuery.wxcode;
      let url = `${path}?`;
      for (const prop in pathQuery) {
        const lastStr = url.charAt(url.length - 1);
        url = `${url}${lastStr === '?' ? '' : '&'}${prop}=${pathQuery[prop]}`;
      }
      const lastUrlStr = url.charAt(url.length - 1);
      if (lastUrlStr === '?') {
        url = url.substring(0, url.length - 1);
      }
      location.href = url;
    }
  },
  [types.SHOW_LOGIN_FORM](state, query) {
    document.body.style.overflowY = 'hidden'; //  隐藏侧边滚动条
    if (query) {
      state.isRegistFirst = query.isRegistFirst || false;
      state.bindWechatInfo = query.bindWechatInfo || null;
    }
    state.isLoginFormShow = true;
  },
  //  传入一个只有关注用户id的数组
  [types.UPDATE_FOLLOWS](state, ids) {
    const newVal = {};
    ids.forEach((id) => {
      newVal[id] = true;
    });
    state.followList = newVal;
  },
  [types.FOLLOW](state, id) {
    const newVal = {};
    for (const uid in state.followList) {
      newVal[uid] = true;
    }
    newVal[id] = true;
    state.followList = newVal;
  },
  [types.UNFOLLOW](state, id) {
    const newVal = {};
    for (const uid in state.followList) {
      if (parseInt(uid) !== id) {
        newVal[uid] = true;
      }
    }
    state.followList = newVal;
  },
  [types.STOCKFOCUS](state, id) {
    const newVal = {};
    for (const stockid in state.stockFocusList) {
      newVal[stockid.toLowerCase()] = true;
    }
    newVal[id.toLowerCase()] = true;
    state.stockFocusList = newVal;
  },
  [types.UNSTOCKFOCUS](state, id) {
    const newVal = {};
    for (const stockid in state.stockFocusList) {
      if (stockid.toLowerCase() !== id.toLowerCase()) {
        newVal[stockid.toLowerCase()] = true;
      }
    }
    state.stockFocusList = newVal;
  },
  /**
   * @description 设置用户信息
   * @param { object } state 操作对象
   * @param { object } data 更新数据
   */
  [types.SET_LOGININFO](state, data) {
    const info = Object.assign({}, state.loginInfo);
    Object.assign(info, data);
    state.loginInfo = info;
  },
  [types.UPDATE_USER_INFO](state, user) {
    const newLoginInfo = Object.assign({}, state.loginInfo);
    Object.assign(newLoginInfo, {
      user,
    });
    state.loginInfo = newLoginInfo;
    this.commit(`user/${types.USER_SIGNIN}`, newLoginInfo);
  },
  //  主题关注列表
  [types.UPDATE_FOCUS](state, ids) {
    const subjectVal = {};
    ids.forEach((id) => {
      subjectVal[id] = true;
    });
    state.focusList = subjectVal;
  },
  [types.FOCUS](state, id) {
    const subjectVal = {};
    for (const uid in state.focusList) {
      subjectVal[uid] = true;
    }
    subjectVal[id] = true;
    state.focusList = subjectVal;
  },
  [types.UNFOCUS](state, id) {
    const subjectVal = {};
    for (const uid in state.focusList) {
      if (parseInt(uid) !== id) {
        subjectVal[uid] = true;
      }
    }
    state.focusList = subjectVal;
  },
  //  得到一个用户关注了的股票id列表
  [types.UPDATE_STOCK_FOCUS](state, ids) {
    const newVal = {};
    ids.forEach((id) => {
      newVal[id.toLowerCase()] = true;
    });
    state.stockFocusList = newVal;
  },
  [types.SET_VIP_MEMBER_INFO](state, query) {
    state.vipMemberInfo = query;
  },
  /**
   * @description 更新认证数据
   * @param { Object } state 操作数据
   * @param { Object } query 更新数据
   */
  [types.SET_USER_INFO_KYC](state, query) {
    if (state.loginInfo) {
      if (state.loginInfo.kyc) {
        Object.assign(state.loginInfo.kyc, query);
      } else {
        state.loginInfo.kyc = query;
      }
    }
  },
};

export const actions = {
  [types.LOGIN_LOCAL]({ commit, dispatch }) {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user === null) {
      return;
    }
    axios(userApi.getLoginStatus())
      .then((res) => {
        if (res.data.statusCode === 200) {
          commit(types.USER_SIGNIN, user);
          //  登录成功时获取关注列表
          dispatch(types.GET_FOLLOWS);
          //  登录成功时获取主题列表
          dispatch(types.GET_FOCUS);
          //  登录成功时获取股票关注列表
          setTimeout(() => {
            //  登录有延迟
            dispatch(types.GET_STOCK_FOCUS);
          }, 500);
          //  登录成功时获取用户info 和粉丝数关注数股票数发表数--wym
          dispatch(types.GET_USER_COUNT);
        } else {
          commit(types.USER_SIGNOUT);
        }
      })
      .catch((err) => {
        // console.log(err);
      });
  },
  [types.LOGOUT]({ commit, dispatch }) {
    axios(userApi.loginOut())
      .then((res) => {
        if (res.data.statusCode === 200) {
          commit(types.USER_SIGNOUT);
          commit(types.SET_VIP_MEMBER_INFO, null);
        } else {
          commit(types.USER_SIGNOUT);
        }
        //  如果微信登录且未绑定手机号退出登录，路由重定向
        const path = location.pathname;
        const pathQuery = getUrlQuery(location.href);
        if (pathQuery && pathQuery.wxcode) {
          delete pathQuery.wxcode;
          let url = `${path}?`;
          for (const prop in pathQuery) {
            const lastStr = url.charAt(url.length - 1);
            url = `${url}${lastStr === '?' ? '' : '&'}${prop}=${
              pathQuery[prop]
            }`;
          }
          const lastUrlStr = url.charAt(url.length - 1);
          if (lastUrlStr === '?') {
            url = url.substring(0, url.length - 1);
          }
          location.href = url;
        }
        if (reloadRoute()) {
          //  会员体系相关页面退出后刷新页面
          location.reload();
        }
      })
      .catch((err) => {
        // console.log(err);
      });
  },
  [types.GET_FOLLOWS]({ commit, getters }) {
    axios(
      userApi.getFollowings({
        id: getters.userId,
        page: 1,
        count: 500,
      })
    )
      .then((res) => {
        if (res.data.statusCode === 200) {
          const ids = res.data.result
            ? res.data.result.map((user) => {
                return user.id;
              })
            : [];
          commit(types.UPDATE_FOLLOWS, ids);
        }
      })
      .catch((err) => {
        // console.log(err);
      });
  },
  [types.GET_FOCUS]({ commit, getters }) {
    axios(
      userApi.getFocus({
        userId: getters.userId,
        page: 1,
      })
    )
      .then((res) => {
        if (res.data.statusCode === 200) {
          const ids = res.data.result
            ? res.data.result.map((item) => {
                return item.subjectId;
              })
            : [];
          commit(types.UPDATE_FOCUS, ids);
        }
      })
      .catch((err) => {
        // console.log(err);
      });
  },
  [types.GET_STOCK_FOCUS]({ commit, getters }) {
    axios(userApi.getMyStock({})).then((res) => {
      if (res.data.statusCode === 200) {
        const ids = res.data.result
          ? res.data.result.map((stock) => {
              return stock[1].toLowerCase() + stock[0];
            })
          : [];
        commit(types.UPDATE_STOCK_FOCUS, ids);
      }
    });
  },
  //  获取用户info和粉丝数，关注数，发表数 ， 股票数  --wym
  [types.GET_USER_COUNT]({ commit, getters }) {
    axios(api.getUserInfo({}))
      .then((res) => {
        if (res.data.statusCode === 200) {
          const user = res.data.result;
          commit(types.USER_SIGNIN, user);
        }
      })
      .catch((err) => {
        // console.log(err);
      });
  },
  /**
   * @description 更新用户会员信息
   * @param { Object } param0 操作对象
   * @param { Object } query 更新数据
   */
  updateVipMemberInfo({ commit }, query) {
    commit(types.SET_VIP_MEMBER_INFO, query);
  },
  updateUserInfoKyc({ state, commit }, query) {
    commit(types.SET_USER_INFO_KYC, query);
  },
  /**
   * @description 确认登陆状态
   * @param { object } state 操作对象
   * @param { object } query 请求参数
   */
  checkLogin({ state, commit }, query) {
    if (!state.isLogin) {
      commit(types.SHOW_LOGIN_FORM, query);
    }
    return state.isLogin;
  },
  // 获取用户关注数量
  //  [types.UPDATE_FOLLOWING_COUNT]({
  //    commit
  //  }, count) {
  //    commit(types.GET_FOLLOWING_COUNT, count)
  //  }
};
